// @ts-nocheck
export default class Event {
  constructor(type) {
    this.type = type;
    this.target = undefined;
  }
}
